"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "acquaviva-picena": {
    "6eece28f": [{
      "hkey": "157edec9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "abbadetta": [{
      "hkey": "157edec9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "acquaviva-picena"
    }],
    "f3cd1e75": [{
      "hkey": "d03d583b",
      "slug": "acquaviva-picena",
      "name": "Acquaviva Picena",
      "primary": true,
      "skipSearch": false
    }],
    "casarica": [{
      "hkey": "d03d583b",
      "slug": "acquaviva-picena",
      "name": "Acquaviva Picena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c8d11da": [{
      "hkey": "d03d583b",
      "slug": "acquaviva-picena",
      "name": "Acquaviva Picena",
      "primary": true,
      "skipSearch": false
    }],
    "forola": [{
      "hkey": "d03d583b",
      "slug": "acquaviva-picena",
      "name": "Acquaviva Picena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa496e74": [{
      "hkey": "d03d583b",
      "slug": "acquaviva-picena",
      "name": "Acquaviva Picena",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-delle-piane": [{
      "hkey": "d03d583b",
      "slug": "acquaviva-picena",
      "name": "Acquaviva Picena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf7bf3c0": [{
      "hkey": "157edec9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "quercia": [{
      "hkey": "157edec9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "acquaviva-picena"
    }],
    "e8f7691c": [{
      "hkey": "3bc33cad",
      "slug": "zona-industriale",
      "name": "Zona Industriale",
      "primary": true,
      "skipSearch": false
    }],
    "sant-angelo-zona-industriale": [{
      "hkey": "3bc33cad",
      "slug": "zona-industriale",
      "name": "Zona Industriale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;